import { render, staticRenderFns } from "./qtxtbtns.vue?vue&type=template&id=6d9b197a&"
import script from "./qtxtbtns.vue?vue&type=script&lang=js&"
export * from "./qtxtbtns.vue?vue&type=script&lang=js&"
import style0 from "./qtxtbtns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VTextField})
